// extracted by mini-css-extract-plugin
module.exports = {"ButtonContainer":"AddBewohner_ButtonContainer__1pfSv","msg":"AddBewohner_msg__3d-Bu"};